import Feature from 'ol/Feature';
import Collection from 'ol/Collection';
import { Style, Fill, Stroke } from 'ol/style';
import { Translate } from 'ol/interaction';
import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import { createOrUpdate } from 'ol/extent';
import map from 'lodash/map';
import { getCenter } from 'ol/extent';
import { fromExtent } from 'ol/geom/Polygon';
import { sync } from 'vuex-pathify';
export default {
  data: () => ({
    paperSeries: {
      a1: [81.7, 57.0],
      a2: [57.7, 40.0],
      a3: [40.2, 28.0],
      a4: [28.7, 20.1],
    },
  }),
  computed: {
    isCardInfoPrint: sync('tools/toolStatus@isCardInfoPrintActive'),
  },
  methods: {
    addPrintExtentLayer() {
      const feature = new Feature({});
      const features = new Collection();
      features.push(feature);
      const printExtentLayer = new VectorLayer({
        id: 'printExtentLayer',
        source: new VectorSource({
          features,
        }),
        zIndex: 10000,
        visible: true,
        style: new Style({
          fill: new Fill({
            color: 'rgba(200, 0, 0, 0.6)',
          }),
          stroke: new Stroke({
            color: 'rgba(255, 0, 0, 1)',
            width: 2,
          }),
        }),
      });
      this.map.addLayer(printExtentLayer);

      const translate = new Translate({ features });
      translate.on('translateend', () => {
        const layer = this.getLayerById('printExtentLayer');
        if (layer) {
          const geometry = layer.feature.getGeometry();
          const center = getCenter(geometry.getExtent());
          this.$root.$emit('updatePrintExtentCenter', center);
        }
      });
      this.map.addInteraction(translate);

      printExtentLayer.feature = feature;
      printExtentLayer.translate = translate;
    },
    calculatePrintExtent(props) {
      const { scale, paper_format, orientation } = props;
      const center = this.map.getView().getCenter();

      let paperSize = this.paperSeries[paper_format];
      if (orientation === 'vertical') {
        paperSize = [paperSize[1], paperSize[0]];
      }

      const paperToMapunit = map(paperSize, v => (v * scale) / 100);

      const dx = paperToMapunit[0] / 2;
      const dy = paperToMapunit[1] / 2;
      const x = center[0];
      const y = center[1];
      const x1 = x - dx;
      const x2 = x + dx;
      const y1 = y - dy;
      const y2 = y + dy;

      return createOrUpdate(Math.min(x1, x2), Math.min(y1, y2), Math.max(x1, x2), Math.max(y1, y2));
    },
    refreshPrintExtentGeometry(props) {
      const printExtent = this.calculatePrintExtent(props);
      const geometry = fromExtent(printExtent);
      const { map_rotation } = props;
      const radiansMapRotation = 0 + (map_rotation * Math.PI) / 180;
      const center = getCenter(geometry.getExtent());
      geometry.rotate(radiansMapRotation, center);
      if (geometry) {
        const layer = this.getLayerById('printExtentLayer');
        if (layer) {
          layer.feature.setGeometry(geometry);
          const center = getCenter(geometry.getExtent());
          this.$root.$emit('updatePrintExtentCenter', center);
        }
      }
    },
    updatePrintBox(props) {
      const layer = this.getLayerById('printExtentLayer');
      if (!layer) {
        this.addPrintExtentLayer();
      }
      this.refreshPrintExtentGeometry(props);
    },
    clearPrintBox() {
      const layer = this.getLayerById('printExtentLayer');
      if (layer) {
        layer.feature.setGeometry(null);
      }
    },
    printCardInfo() {
      this.isCardInfoPrint = true;
      this.$nextTick(() => {
        window.print();
      });
      window.onafterprint = () => {
        this.isCardInfoPrint = false;
      };
    },
  },
  mounted() {
    this.$root.$off('updatePrintBox');
    this.$root.$off('clearPrintBox');
    this.$root.$off('printCardInfo');
    this.$root.$on('updatePrintBox', this.updatePrintBox);
    this.$root.$on('clearPrintBox', this.clearPrintBox);
    this.$root.$on('printCardInfo', this.printCardInfo);
  },
};
